import { render, staticRenderFns } from "./HerdCharacteristics.vue?vue&type=template&id=a9a5ee6c&scoped=true&"
import script from "./HerdCharacteristics.vue?vue&type=script&lang=js&"
export * from "./HerdCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./HerdCharacteristics.vue?vue&type=style&index=0&id=a9a5ee6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a5ee6c",
  null
  
)

export default component.exports